import React, { useContext, useEffect, useCallback } from "react";
// import { googleMapsPlacesAPI } from "../components/GoogleAutoComplete";
import WithinCityQuote from "./WithinCityQuote";
import BetweenCityQuote from "./BetweenCityQuote";
import MovePlannerContext from "../../context/move_planner/movePlanner";
import { activeCityListAPI } from "../../adapters/estimate/estimateAdapters";
import { useSelector, useDispatch } from "react-redux";
import {
  WithinCityMoveSkeleton,
  BetweenCityMoveSkeleton,
} from "../skeleton/estimate/moveInfo";
import { thunkLoadMoveInfoFromSession } from "../../redux/reducers/move_info/moveInfoReducer";

function GetEstimate(props) {
  //get the init data from redux store and set to useForm
  const context = useContext(MovePlannerContext);
  const moveInfoState = useSelector((state) => state.moveInfo);

  const {
    moveType,
    setMoveType,
    isCityListLoading,
    setIsCityListFetching,
    cityList,
    setCityList,
    hasError,
    setHasError,
    onSubmit,
  } = props.state;

  // global state access.
  const dispatch = useDispatch();

  // react-form-hook
  const { register, handleSubmit: moveInfoSubmit } =
    context.estimateForm.useMoveInfoForm;

  const loadFromSession = useCallback(() => {
    if (
      moveInfoState.hasLoadedFromSession === false &&
      sessionStorage.getItem("move_info") !== null
    ) {
      const data = sessionStorage.getItem("move_info");
      dispatch(thunkLoadMoveInfoFromSession({ moveInfo: data }));
    }
  }, [dispatch, moveInfoState.hasLoadedFromSession]);

  const changeMoveType = useCallback(
    (type) => {
      setMoveType(type);
    },
    [setMoveType]
  );

  useEffect(() => {
    if (cityList !== null) {
      return;
    }
    setIsCityListFetching(true);
    const getCityList = async function (data) {
      try {
        const response = await activeCityListAPI();
        //load move info state from local stored session.
        loadFromSession();
        setCityList(response.data.ServiceCity);
        setIsCityListFetching(false);

        return response;
      } catch (error) {
        setIsCityListFetching(false);
        setHasError(true);
        // TODO : create a error display components, handle error rendering
        console.error(error);
      }
    };
    getCityList();
    // eslint-disable-next-line
  }, [loadFromSession, setIsCityListFetching, setCityList, setHasError]);

  useEffect(() => {
    changeMoveType(moveInfoState.moveType);
  }, [moveInfoState.moveType, changeMoveType]);

  const JSX = (
    <>
      <div className="col-sm-12 col-md-6 col-lg-6 col-xl-12">
        <div className="row">
          <div className="col-12 move-details-section">
            <form
              id="makeEstimateForm"
              autoComplete="off"
              className="col-12"
              noValidate={true}
              method="POST"
              onSubmit={moveInfoSubmit(onSubmit)}
            >
              <div className="move-details-container">
                <div className="move-type">
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="withinCity"
                      ref={register}
                      onChange={(e) => {
                        changeMoveType("Within City");
                      }}
                      name="city_type"
                      value="Within City"
                      checked={moveType === "Within City" ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="withinCity"
                    >
                      Within City
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="interCity"
                      onChange={(e) => {
                        changeMoveType("Inter City");
                      }}
                      ref={register}
                      name="city_type"
                      value="Inter City"
                      checked={moveType === "Inter City" ? true : false}
                    />
                    <label className="custom-control-label" htmlFor="interCity">
                      Inter City
                    </label>
                  </div>
                </div>
                {/* <!-- START : within city --> */}
                {moveType === "Within City" && isCityListLoading === true && (
                  <WithinCityMoveSkeleton />
                )}

                {hasError === false && isCityListLoading === false && (
                  <WithinCityQuote
                    cityList={cityList}
                    enabled={moveType === "Within City" ? true : false}
                  />
                )}
                {/* <!-- END : within city --> */}

                {/* <!-- START : Between city --> */}
                {moveType === "Inter City" && isCityListLoading === true && (
                  <BetweenCityMoveSkeleton />
                )}

                {hasError === false && isCityListLoading === false && (
                  <BetweenCityQuote
                    enabled={moveType === "Inter City" ? true : false}
                  />
                )}
                {/* <!-- END : Between city --> */}
              </div>
            </form>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}

export default GetEstimate;
